import React, { useState, useEffect, useCallback } from "react";
import { useParams, useHistory } from "react-router-dom";
import { connect } from "react-redux";

import MakeAPICall from "../../apiCalls/common";

import appRoutes from "../../routes/appRoutes";

import APP_CONSTANTS from "../../constants";

import {
  // getSupportStaffApiRoute,
  getTicketByIdApiRoute,
  deleteTicketApiRoute,
  editTicketApiRoute,
  sendDoctorTicketNotificationAPI,
  doctorNotes,
  editdoctorNotes,
  deletedoctorNotes,
  doctoreAction
} from "../../apiRoutes";

import Loader from "../../components/loader";
import CustomModal from "../../components/modal";
import EditTicketForm from "../../containers/Tickets/editTicketForm";
import { setTicketCount } from "../../reduxStore/actions/serverConstants"

const EditTicketPage = props => {
  let history = useHistory();
  // useParams returns an object of key/value pairs of URL parameters. Use it to access match.params of the current route
  let { id } = useParams();

  const [isProcessing, setIsProcessing] = useState(false);
  const [apiCallParams1, setApiCallParams1] = useState(null);
  const [apiCallParams2, setApiCallParams2] = useState(null);
  const [apiCallParams3, setApiCallParams3] = useState(null);
  const [apiCallParams4, setApiCallParams4] = useState(null);
  const [apiCallParams5, setApiCallParams5] = useState(null);
  const [apiCallParams6, setApiCallParams6] = useState(null);
  const [apiCallParams7, setApiCallParams7] = useState(null);
  const [staff, setStaff] = useState([]);
  const [ticketData, setTicketData] = useState(null);
  const [showDelModal, setToggleDelModal] = useState(false);
  const [showDelSuccessModal, setToggleDelSuccessModal] = useState(false);
  const [showUpdateSuccessModal, setToggleUpdateSuccessModal] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [updateSuccess, setUpdateSuccess] = useState(null);
  const [showNotificationSuccessModal, setShowNotificationSuccessModel] = useState(false);
  const [showMarkAsActionedSuccessModal, setShowMarkAsActionedSuccessModel] = useState(false);
  const [showTicketNotificationError, setShowTicketNotificationError] = useState(false);

  // get the staff list
  // const getSupportStaffData = useCallback(() => {
  //   setApiCallParams1({
  //     reqType: "GET",
  //     reqUrl: getSupportStaffApiRoute,
  //     params: {
  //       skip: 0,
  //       limit: 0
  //     },
  //     successCallback: async res => {
  //       const staffList = [];
  //       await res.data.data.staffs.forEach(staff => {
  //         if (staff.isBlocked === false) {
  //           let staffName = '';
  //           if (staff.firstName === "System" && staff.lastName === "System") {
  //             staffName = 'Instant Consult';
  //           } else {
  //             staffName = staff.firstName + " " + staff.lastName;
  //           }
  //           staffList.push({
  //             id: staff._id,
  //             name: staffName
  //           });
  //         }
  //       });
  //       setStaff(staffList);
  //     },
  //     failureCallback: err => {}
  //   });
  // }, []);

  // get ticket data
  const getTicketData = useCallback(id => {
    setIsProcessing(true);
    setApiCallParams2({
      reqType: "GET",
      reqUrl: getTicketByIdApiRoute,
      params: { ticketId: id },
      successCallback: async res => {
        setIsProcessing(false);
        setTicketData(res.data.data);
        setUpdateSuccess(res.data.data);
      },
      failureCallback: err => {}
    });
  }, []);

  // merge-ticket-documents already returns the full updated ticket, so just use it directly
  const onMergeSuccess = updatedTicket => {
    setTicketData(updatedTicket);
    setUpdateSuccess(updatedTicket);
  };

  //delete the ticket
  const deleteTicket = () => {
    setIsProcessing(true);
    setToggleDelModal(false);
    setApiCallParams1({
      reqType: "DELETE",
      reqUrl: deleteTicketApiRoute + id,
      successCallback: res => {
        setIsProcessing(false);
        setToggleDelSuccessModal(true);
      },
      failureCallback: err => {}
    });
  };

  const delSuccessModalOkay = () => {
    setToggleDelSuccessModal(false);
    history.push(appRoutes.viewTickets);
  };

  const updateSuccessModalOkay = () => {
    setToggleUpdateSuccessModal(false);
    history.push(appRoutes.viewTickets);
  };

  useEffect(() => {
    getTicketData(id);

    // getSupportStaffData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //update ticket data
  const updateTicketData = data => {
    setIsProcessing(true);
    setApiCallParams1({
      reqType: "PUT",
      reqUrl: editTicketApiRoute + id,
      dataObj: data,
      successCallback: async res => {
        setErrorMsg("");
        setIsProcessing(false);
        getTicketData(id);
        setToggleUpdateSuccessModal(true);
        if (res.data && res.data.data.adminActionCount) {
          // props.setTicketCount(res.data.data.adminActionCount[props.user?._id]);
          if (props.user.userType !== "SUPPORT_STAFF") {
            let count = 0;
            for (const userId in res.data.data.adminActionCount) {
              count += res.data.data.adminActionCount[userId];
            }
            props.setTicketCount(count);
          } else {
            props.setTicketCount(res.data.data.adminActionCount[props.user?._id] || 0);
          }
        }
      },
      failureCallback: err => {
        setIsProcessing(false);
        //setErrorMsg(err.error);
      }
    });
  };

  const updateTicketSubjectData = data => {
    setIsProcessing(true);
    setApiCallParams1({
      reqType: "PUT",
      reqUrl: editTicketApiRoute + id,
      dataObj: data,
      successCallback: async res => {
        setErrorMsg("");
        setIsProcessing(false);
        // setToggleUpdateSuccessModal(true);
        getTicketData(id);
        if (res.data && res.data.data.adminActionCount) {
          props.setTicketCount(res.data.data.adminActionCount[props.user?._id]);
        }
      },
      failureCallback: err => {
        setIsProcessing(false);
        //setErrorMsg(err.error);
      }
    });
  }

  const goToPatientPMSPortal = patId => {
    if (patId !== null) {
      const auth = props.user;
      window.open(
        APP_CONSTANTS.pmsURL +
          "/patient/patientDetails?accessToken=" +
          auth.accessToken +
          "&patientId=" +
          patId +
          "&searchType=" +
          auth.userType +
          "&adminName=" +
          auth.firstName +
          " " +
          auth.lastName,
        "_blank"
      );
    }
  };

  const goToDoctorProfile = docId => {
    if (docId !== null) {
      //window.open(appRoutes.doctorApproved + "/" + docId, "_blank");
      history.push(appRoutes.doctorApproved + "/" + docId);
    }
  };

  const sendTicketNotification = (to, doctorId, patientId, message, isInprogressReportsReceivedAndNotified) => {
    setIsProcessing(true);
    let notificaitonData = {
      doctorId: doctorId,
      notificationMsg: message,
      notifiedBy: props.user._id,
      ticketId: ticketData._id,
      user: to,
      patientId: patientId,
      isInprogressReportsReceivedAndNotified: (isInprogressReportsReceivedAndNotified === true ? true : false)
    }
    setApiCallParams3({
      reqType: "POST",
      reqUrl: sendDoctorTicketNotificationAPI,
      dataObj: notificaitonData,
      successCallback: async res => {
        setIsProcessing(false);
        setShowNotificationSuccessModel(true);
        getTicketData(id);
      },
      failureCallback: err => {
        setIsProcessing(false);
        console.log("Getting error in ticket: ", err);
        if(err.type === "USER_BLOCKED"){
          setShowTicketNotificationError(true);
        }else{
          setErrorMsg(err.error);
        }
      }
    });
  }

  const sendMarkAsActionedNotification = (data) => {
      setIsProcessing(true);
      setApiCallParams1({
        reqType: "PUT",
        reqUrl: editTicketApiRoute + id,
        dataObj: data,
        successCallback: async res => {
          setIsProcessing(false);
          setShowMarkAsActionedSuccessModel(true);
          if (res.data) {
            if (res.data && res.data.data.adminActionCount) {
              props.setTicketCount(res.data.data.adminActionCount[props.user?._id]);
            }
            getTicketData(id);
          }
        },
        failureCallback: err => {
          setIsProcessing(false);
          //setErrorMsg(err.error);
        }
      });
  }

  const closeNotificationSuccessModel = () => {
    setShowNotificationSuccessModel(false);
  }
  const closeMarkAsActionedSuccessModel = () => {
    setShowMarkAsActionedSuccessModel(false);
  }

  const closeTicketNotificationError = () => {
    setShowTicketNotificationError(false);
  }

  const addNotes = (_id, data) => {
    setApiCallParams4({
      reqType: "POST",
      reqUrl: doctorNotes,
      dataObj: {
        ticketId: _id,
        note: data,
      },
      successCallback: async res => {
        getTicketData(_id)
      },
      failureCallback: err => {
        //setErrorMsg(err.error);
      }
    });
  }
  const editNotes = (_id, adminId, data) => {
    setApiCallParams5({
      reqType: "POST",
      reqUrl: editdoctorNotes,
      dataObj: {
        ticketId: _id,
        adminNoteId: adminId,
        note: data,
      },
      successCallback: async res => {
        getTicketData(_id)
      },
      failureCallback: err => {
        //setErrorMsg(err.error);
      }
    });
  }
  const deleteNotes = (_id, adminId) => {
    setApiCallParams6({
      reqType: "POST",
      reqUrl: deletedoctorNotes,
      dataObj: {
        ticketId: _id,
        adminNoteId: adminId,
      },
      successCallback: async res => {
        getTicketData(_id)
      },
      failureCallback: err => {
        //setErrorMsg(err.error);
      }
    });
  }

  const doctoreNotesRequired = (_id, doctoreId) => {
    setApiCallParams7({
      reqType: "POST",
      reqUrl: doctoreAction,
      dataObj: {
        ticketId: _id,
        doctorNoteId: doctoreId,
      },
      successCallback: async res => {
        setShowMarkAsActionedSuccessModel(true)
        getTicketData(_id)
      },
      failureCallback: err => {
        //setErrorMsg(err.error);
      }
    });
  }

  return (
    <div className="view-ticket-container">
      {isProcessing && <Loader />}
      <div className={isProcessing ? "disableContainer" : ""}>
        <EditTicketForm
          staffList={props.supportStaff}
          data={ticketData}
          addNotes={addNotes}
          editNotes={editNotes}
          deleteNotes={deleteNotes}
          deleteTicket={setToggleDelModal}
          updateTicketData={updateTicketData}
          updateTicketSubjectData={updateTicketSubjectData}
          updateSuccess={updateSuccess}
          errorMessage={errorMsg}
          goToPatientPMSPortal={goToPatientPMSPortal}
          goToDoctorProfile={goToDoctorProfile}
          sendTicketNotification={sendTicketNotification}
          sendMarkAsActionedNotification={sendMarkAsActionedNotification}
          doctoreNotesRequired={doctoreNotesRequired}
          currentUserId={props.user._id}
          currentUserType={props.user.userType}
          onMergeSuccess={onMergeSuccess}
        />
      </div>
      <CustomModal
        okayText="Yes"
        cancelText="No"
        openModal={showDelModal}
        cancelEvent={e => setToggleDelModal(false)}
        okayEvent={deleteTicket}
        modalBodyContent={
          <p className="text-center mb-0">
            Are you sure you want to delete this ticket?
          </p>
        }
      />
      <CustomModal
        useOneButton={true}
        cancelText="OKAY"
        openModal={showDelSuccessModal}
        cancelEvent={delSuccessModalOkay}
        okayEvent={delSuccessModalOkay}
        modalBodyContent={
          <p className="text-center mb-0">Ticket Deleted Successfully</p>
        }
      />
      <CustomModal
        useOneButton={true}
        cancelText="OKAY"
        openModal={showUpdateSuccessModal}
        cancelEvent={updateSuccessModalOkay}
        okayEvent={updateSuccessModalOkay}
        modalBodyContent={
          <p className="text-center mb-0">Ticket Updated Successfully</p>
        }
      />
       <CustomModal
        useOneButton={true}
        cancelText="OKAY"
        openModal={showNotificationSuccessModal}
        cancelEvent={closeNotificationSuccessModel}
        okayEvent={closeNotificationSuccessModel}
        modalBodyContent={
          <p className="text-center mb-0">Notification Successfully Sent</p>
        }
      />
       <CustomModal
        useOneButton={true}
        cancelText="OKAY"
        openModal={showMarkAsActionedSuccessModal}
        cancelEvent={closeMarkAsActionedSuccessModel}
        okayEvent={closeMarkAsActionedSuccessModel}
        modalBodyContent={
          <>
            <p className="text-center mb-0">Marked as Actioned Successfully</p>
            <p className="text-center mb-0">Please remember to save this ticket!</p>
          </>
        }
      />
       <CustomModal
        useOneButton={true}
        cancelText="OKAY"
        openModal={showTicketNotificationError}
        cancelEvent={closeTicketNotificationError}
        okayEvent={closeTicketNotificationError}
        title="Notification Not Sent"
        modalBodyContent={
          <p className="text-center mb-0">User Blocked</p>
        }
      />
      {/* API Call */}
      <MakeAPICall apiParam={apiCallParams1} />
      <MakeAPICall apiParam={apiCallParams2} />
      <MakeAPICall apiParam={apiCallParams3} />
      <MakeAPICall apiParam={apiCallParams4} />
      <MakeAPICall apiParam={apiCallParams5} />
      <MakeAPICall apiParam={apiCallParams6} />
      <MakeAPICall apiParam={apiCallParams7} />
    </div>
  );
};

const mapStateToProps = state => ({
  user: state.auth.user,
  supportStaff: state.serverConstants.supportStaff,
});

const mapDispatchToProps = dispatch => ({
  setTicketCount: data => dispatch(setTicketCount(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditTicketPage);
